function Setting (){
    return <h1>Settings</h1>
}

export default Setting